import { collection, addDoc, serverTimestamp } from "firebase/firestore";
import { db } from "../../../../firebase";

/**
 * saveClassificationResult
 * Saves the classification result, summary, and file details to Firestore
 * under the user's selected folder in the single_page subcollection.
 *
 * @param {string} userId - Current user's ID
 * @param {object} selectedFolder - The folder object selected by the user
 * @param {object} file - The file object being classified
 * @param {object} classificationResult - The classification result object
 * @param {string} confirmedCategory - The confirmed classification category key
 * @param {string} summary - The summary text
 * @returns {Promise<string>} - The ID of the created Firestore document
 */
export async function saveClassificationResult(
  userId,
  selectedFolder,
  file,
  classificationResult,
  confirmedCategory,
  summary
) {
  if (!userId) throw new Error("User ID is required");
  if (!selectedFolder || !selectedFolder.folderId)
    throw new Error("Selected folder is required");
  if (!file || !file.id) throw new Error("File information is required");
  if (!classificationResult)
    throw new Error("Classification result is required");
  if (!confirmedCategory) throw new Error("Confirmed category is required");

  console.log("inside saveClassificationResult.js");
  const docData = {
    fileName: file.name || "",
    fileSize: file.size || 0,
    fileType: file.type || "",
    fileId: file.id,
    storagePath: file.storagePath || "",
    downloadURL: file.downloadURL || "",
    downloadPDFURL: file.downloadPDFURL || "",
    classificationCategory: confirmedCategory,
    // classificationConfidence:
    //   classificationResult.page?.predictions?.[0]?.confidence || null,
    // classificationProbabilities:
    //   classificationResult.page?.predictions?.[0]?.probability || null,
    summary: summary || "",
    userId,
    folderId: selectedFolder.folderId,
    createdAt: serverTimestamp(),
  };

  // Choose collection based on file.page and file.type (PDF only for multi_page)

  let collectionRef;
  const pageCount = parseInt(file.page, 10); // Always returns a number or NaN

  if (!isNaN(pageCount) && pageCount > 1 && file.type === "application/pdf") {
    collectionRef = collection(
      db,
      "users",
      userId,
      "folders",
      selectedFolder.folderId,
      "accreditation_folder",
      "main",
      "multi_page"
    );
  } else {
    collectionRef = collection(
      db,
      "users",
      userId,
      "folders",
      selectedFolder.folderId,
      "accreditation_folder",
      "main",
      "single_page"
    );
  }
  const docRef = await addDoc(collectionRef, docData);
  return docRef.id;
}
